var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVoting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3778 13.6387C17.7565 13.0074 18.7142 11.6155 18.7142 10C18.7142 7.79086 16.9234 6 14.7142 6C12.5051 6 10.7142 7.79086 10.7142 10C10.7142 11.6276 11.6864 13.0282 13.0817 13.6528",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7142 10C18.7142 7.79086 16.9234 6 14.7142 6C12.5051 6 10.7142 7.79086 10.7142 10",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9242 15.4995C15.9242 14.5403 15.9242 13.1014 15.9242 11.1829C15.9242 10.5296 15.3946 10 14.7413 10C14.0881 10 13.5585 10.5296 13.5585 11.1829V20.6511L10.0947 18.2516C9.95503 17.9678 9.87018 18.0222 9.57014 17.9222C9.27009 17.8222 8.94249 17.8465 8.66049 17.9897C8.37673 18.1294 8.16072 18.3769 8.0607 18.6769C7.96069 18.977 7.985 19.3046 8.12821 19.5866L13.6176 25.3234M15.9242 15.9143C15.9242 15.261 16.4538 14.7314 17.1071 14.7314C17.7603 14.7314 18.2899 15.261 18.2899 15.9143M18.3195 15.9143C18.3195 15.261 18.8195 15.3229 19.4728 15.3229C20.1261 15.3229 20.6556 15.8524 20.6556 16.5057",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6177 25.3234C14.1616 26.2058 15.1242 26.7431 16.1608 26.7429H20.0642C21.6974 26.7429 23.0214 25.4189 23.0214 23.7857V17.6886C23.0214 17.0353 22.0619 16.2688 21.4086 16.2688",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoting);
export default __webpack_public_path__ + "static/media/voting.e1aac1f12fca52700b2f3b825d8d3d49.svg";
export { ForwardRef as ReactComponent };